import type { ProfileDetail } from "@/interface";
import {
  Briefcase,
  FileCode2,
  Award,
  Trophy,
  GraduationCap,
} from "lucide-react";

interface CandidateKpisProps {
  profile: ProfileDetail;
  projectsCount: number;
  skillsCount: number;
  certsCount: number;
  awardsCount: number;
  educationCount: number;
}

export function CandidateKpis({
  profile,
  projectsCount,
  skillsCount,
  certsCount,
  awardsCount,
  educationCount,
}: CandidateKpisProps) {
  const stats = [
    {
      label: "Experience",
      value: `${profile?.experience_years ?? 0}y ${profile?.experience_months ?? 0}m`,
      icon: Briefcase,
      color: "text-amber-500",
    },
    {
      label: "Projects",
      value: `${projectsCount}`,
      icon: FileCode2,
      color: "text-purple-500",
    },
    {
      label: "Skills",
      value: `${skillsCount}`,
      icon: Award,
      color: "text-amber-500",
    },
    {
      label: "Certifications",
      value: `${certsCount}`,
      icon: Award,
      color: "text-amber-500",
    },
    {
      label: "Awards",
      value: `${awardsCount}`,
      icon: Trophy,
      color: "text-emerald-500",
    },
    {
      label: "Education",
      value: `${educationCount}`,
      icon: GraduationCap,
      color: "text-purple-500",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
      {stats.map((stat, i) => (
        <div
          key={i}
          className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-4 flex flex-col items-center justify-center text-center shadow-sm hover:border-primary/50 transition-colors"
        >
          <div className="flex items-center gap-2 mb-1">
            <stat.icon className={`h-4 w-4 ${stat.color}`} />
            <span className="text-xs text-slate-500 font-medium">
              {stat.label}
            </span>
          </div>
          <span className={`text-xl font-bold ${stat.color}`}>
            {stat.value}
          </span>
        </div>
      ))}
    </div>
  );
}
